export default __webpack_public_path__ + "static/media/Screenshot_B30.76edc992.jpg";